import React from 'react'

import { TRouteOverrides } from 'helpers/applyRouteOverrides'

import { SubscriptionDetails } from 'modules/unsubscribe/pages'

import { PageId } from 'page-constants'

import { FemiScope } from './components/FemiScope'
import { FemiCancelConfirmation } from './pages/FemiCancelConfirmation'
import { FemiCanceledPlan } from './pages/FemiCanceledPlan'
import { FemiContinuedPlan } from './pages/FemiContinuedPlan'
import { FemiDiscountOffer } from './pages/FemiDiscountOffer'
import { FemiPauseSubscription } from './pages/FemiPauseSubscription'
import { FemiReasons } from './pages/FemiReasons'
import { FemiTechnicalIssues } from './pages/FemiTechnicalIssues'

export const FEMI_RETENTION_ROUTES: TRouteOverrides = {
  [PageId.SUBSCRIPTION_DETAILS]: (
    <FemiScope>
      <SubscriptionDetails />
    </FemiScope>
  ),
  [PageId.REASONS]: <FemiReasons />,
  [PageId.TECHNICAL_ISSUES]: <FemiTechnicalIssues />,
  [PageId.PAUSE_SUBSCRIPTION]: <FemiPauseSubscription />,
  [PageId.DISCOUNT_OFFER]: <FemiDiscountOffer />,
  [PageId.CANCEL_CONFIRMATION]: <FemiCancelConfirmation />,
  [PageId.CONTINUED_SUBSCRIPTION]: <FemiContinuedPlan />,
  [PageId.CANCELED_SUBSCRIPTION]: <FemiCanceledPlan />,
}
